import React from 'react'
import Link from 'gatsby-link'
import FlagIcon from '../components/flagicon'
import moment from 'moment'
import { Container, Row, Col } from 'reactstrap'

// import CountryCodes from 'country-code-info';
import { findCountry } from '../components/helpers/countries'
import { matchName } from '../components/helpers/matchnames'

var worldjson = require('../../node_modules/world-countries/dist/countries.json')

const FinalsPage = props => {
  const matches = props.data.allThirdPartyWorldCupMatches.edges

  function startTime(datetime) {
    return moment(datetime)
      .format('DD.MM.YY HH:mm')
      .toString()
  }

  function searchCountryName(code) {
    for (var i = 0; i < worldjson.length; i++) {
      if (worldjson[i].cca2 == code.toUpperCase()) {
        return worldjson[i].translations.deu.common
      }
    }
  }

  return (
    <div>
      <h1>K.O.-Runde</h1>
      <Container>
        <Row>
          {matches.map((match, i) => {
            const matchData = match.node

            if (
              matchData.stage_name == 'Round of 16' ||
              matchData.stage_name == 'Quarter-finals' ||
              matchData.stage_name == 'Semi-finals' ||
              matchData.stage_name == 'Play-off for third place' ||
              matchData.stage_name == 'Final'
            ) {
              // const code1 = findCountry(matchData.home_team.code).toLowerCase();
              // const code2 = findCountry(matchData.away_team.code).toLowerCase();
              var code1, code2

              if (matchData.home_team.code != 'TBD') {
                code1 = searchCountryName(findCountry(matchData.home_team.code))
              } else {
                code1 = '?'
              }

              if (matchData.away_team.code != 'TBD') {
                code2 = searchCountryName(findCountry(matchData.away_team.code))
              } else {
                code2 = '?'
              }

              const starttime = startTime(matchData.datetime)

              return (
                <Col sm="6" lg="3" key={i}>
                  <h2>{matchName(matchData.stage_name)}</h2>

                  {code1 != '?' || code2 != '?' ? (
                    <p>
                      <FlagIcon
                        code={findCountry(matchData.home_team.code)}
                        size="3x"
                      />&nbsp;&nbsp;&nbsp;<FlagIcon
                        code={findCountry(matchData.away_team.code)}
                        size="3x"
                      />
                    </p>
                  ) : null}

                  <p className="game__result">
                    {code1} vs {code2}
                  </p>

                  {/* <p className="game__result"><FlagIcon code={code1} size="3x" />&nbsp;&nbsp;&nbsp;{searchCountryName(code1.toUpperCase())} vs {searchCountryName(code2.toUpperCase())}&nbsp;&nbsp;&nbsp;<FlagIcon code={code2} size="3x" /></p> */}

                  <p>Ort: {matchData.venue}</p>
                  <p>Beginn: {starttime}</p>

                  <div>
                    {matchData.status != 'future' ? (
                      <p className="game__result">
                        Ergebnis: {matchData.home_team.goals}:{
                          matchData.away_team.goals
                        }{' '}
                      </p>
                    ) : null}
                  </div>
                </Col>
              )
            }
          })}
        </Row>
      </Container>
    </div>
  )
}

export default FinalsPage

export const query = graphql`
  query MyMatchQuery {
    allThirdPartyWorldCupMatches {
      edges {
        node {
          home_team {
            code
            goals
          }
          away_team {
            code
            goals
          }
          venue
          datetime
          winner_code
          stage_name
          status
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/finals.js